import { ensureLegacyGlobals, legacyRoot } from '~/modules/legacyRuntime.js';

function ensureLegacyPublicBridge() {
  return ensureLegacyGlobals();
}

const legacyPublicRoot = ensureLegacyPublicBridge();

export { ensureLegacyPublicBridge, legacyPublicRoot, legacyRoot as browserGlobal };

export default function initLegacyPublicBridge() {
  return ensureLegacyPublicBridge();
}
